import Joi from "joi";

const BedNumberGroupSchema = Joi.object({
  bedSubCategory: Joi.string().trim().required().messages({
    "string.empty": "Sub Category is required.",
  }),
  firstBedNumber: Joi.number().min(0).required().messages({
    "number.empty": "First Bed Number is required.",
    "number.base": "First Bed Number must be a number.",
  }),
  lastBedNumber: Joi.number().min(0).required().messages({
    "number.empty": "Last Bed Number is required.",
    "number.base": "Last Bed Number must be a number.",
  }),
  cost: Joi.number().min(0).optional().messages({
    "number.base": "Cost must be a number.",
    "number.min": "Cost cannot be negative.",
  }),
  bedCount: Joi.number().min(0).optional().messages({
    "number.base": "Bed Count must be a number.",
    "number.min": "Bed Count cannot be negative.",
  }),
}).unknown(true);

export default BedNumberGroupSchema;
